export const getColumnType = (dataType, isLegalUser, isLegalAdmin) => {

    if (dataType === 'titles' && !isLegalAdmin) {
        return 'limited';
    }
    if (dataType === 'products' && !isLegalAdmin && !isLegalUser) {
        return 'limited';
    }
    return 'default';
};
